import React, { useState, useEffect } from "react";
import {
  Field,
  FieldGroup,
  FormCard,
  SubmitButtonMail,
  InputFieldText,
  InputFieldSelect,
} from "../../reusable";
import { FormPartInterface, SaveValueInterface } from "../../../interfaces";
import { useClaimData } from "../../../claimProvider";

export const Adverse = (props: FormPartInterface) => {
  const { isActive, assignGroup, saveValueFunct } = props;
  const [currentStep, setCurrentStep] = useState(0);
  const [postCurrentStep, setPostCurrentStep] = useState(0);
  const [localSideEffects, setLocalSideEffects] = useState<{
    had: "" | "Yes" | "No";
    details: string;
  }>({ had: "", details: "" });
  const [requiredHospitalisation, setRequiredHospitalisation] = useState<
    "" | "Yes" | "No"
  >("");
  const [showErrors, setShowErrors] = useState(false);
  const [isFormValid, setIsFormValid] = useState(true);
  const claim = useClaimData() || {};

  // Initialize state from claim data when component becomes active
  useEffect(() => {
    if (isActive === "adverse" && claim.had_side_effects !== undefined) {
      const hadSideEffects = claim.had_side_effects === "1" ? "Yes" : "No";
      setLocalSideEffects({
        had: hadSideEffects,
        details: claim.side_effect_details || "",
      });
    }
  }, [isActive, claim.had_side_effects, claim.side_effect_details]);

  // Remove automatic validation - only validate when user tries to proceed

  const validateForm = () => {
    // Must select Yes or No for side effects
    if (!localSideEffects.had) {
      return false;
    }

    // If Yes, details are required
    if (localSideEffects.had === "Yes") {
      if (!localSideEffects.details || localSideEffects.details.trim() === "") {
        return false;
      }
    }

    return true;
  };

  const handleBack = () => {
    assignGroup("medication");
  };

  const handleContinue = () => {
    setShowErrors(true);
    if (!validateForm()) return;

    saveValueFunct({
      field: "had_side_effects",
      value: localSideEffects.had === "Yes" ? "1" : "0",
    });
    saveValueFunct({
      field: "side_effect_details",
      value: localSideEffects.details || "",
    });

    assignGroup("review");
  };

  return isActive === "adverse" ? (
    <FieldGroup title="Medical Impact / Adverse Effects">
      <FormCard
        assignPostStep={setPostCurrentStep}
        step={currentStep}
        onBack={handleBack}
        isFirstStep={false}
      >
        <Field
          fieldLabel="Have you experienced any side effects?"
          labelPosition="left"
        >
          <InputFieldSelect
            fieldName="had_side_effects"
            saveValue={(data) => {
              setLocalSideEffects((prev) => ({
                ...prev,
                had: data.value as "Yes" | "No",
              }));
              return { success: true, error: "" };
            }}
            options={[
              { value: "Yes", label: "Yes" },
              { value: "No", label: "No" },
            ]}
            required={true}
            enhanced={true}
            showErrors={showErrors}
          />
        </Field>
        {localSideEffects.had === "Yes" && (
          <Field
            fieldLabel="Please describe (or select common ones)"
            labelPosition="left"
          >
            <InputFieldText
              fieldName="side_effect_details"
              saveValue={(data) => {
                setLocalSideEffects((prev) => ({
                  ...prev,
                  details: data.value,
                }));
                return { success: true, error: "" };
              }}
              populateValue={localSideEffects.details}
              enhanced={true}
            />
          </Field>
        )}

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <SubmitButtonMail
            text="Continue"
            btnType="primary"
            onClick={handleContinue}
            disabled={!isFormValid}
          />
        </div>
      </FormCard>
    </FieldGroup>
  ) : null;
};
